export const auth = {
  //switch login
  REFRESH_TOKEN: '/refresh-token',
  TOKEN_EXCHANGE: '/token-exchange',
  LOGOUT: '/logout',
}
export const iam = {
  // Lấy thông tin user
  USER_INFO: '/user/userInfo',
  ALL_CLIENT: '/client/findAll',
}

export const noti = {
  //Thông báo
  NOTI_APP_SEARCH: '/noti/noti-app/search',
  NOTI_APP_CREATE: '/noti/noti-app/create',
  NOTI_APP_DETAIL: '/noti/noti-app/self',
  NOTI_APP_GET_COUNT_UNREAD: '/noti/noti-app/count-unread',
  NOTI_APP_MARK_READ: '/noti/noti-app/mark-read',
}

export const sys = {
  GET_COMPANY_LIST: '/sys/orgUnit/initTree',
  GET_COMPANY_LIST_ROOT: '/sys/orgUnit/initTree-by-root',
  GET_PROVINCE: '/sys/location/find-province',
  GET_DISTRICT: '/sys/location/find-district',
  GET_COMMUNE: '/sys/location/find-commune',
  GET_GLOBAL_LIST_DETAIL: '/sys/globalListDetail/getListGlobalValueByCode',
  STAFF_SEARCH: '/sys/staff/search',
  GET_ORG_UNIT: '/sys/orgUnitStaff/findByStaffId',
  GET_ORGANIZATIONAL_LIST: '/sys/orgUnit/search',
  STAFF_SEARCH_SYSTEM_CRM: 'sys/staff/crm-v1/responsible-staff',
  STAFF_SEARCH_ORGUNIT_ID: '/sys/orgUnitStaff/getStaffsByOrgUnit',
}
export const wdn = {}

export const wfm = {
  // Nhóm ticket
  TICKET_GROUP_SEARCH: '/ticket-group/search',
  TICKET_GROUP_CREATE: '/ticket-group/create',
  TICKET_GROUP_UPDATE: '/ticket-group/update',
  TICKET_GROUP_UPDATE_STATUS: '/ticket-group/update-status',
  TICKET_GROUP_DELETE: '/ticket-group/delete',
  TICKET_GROUP_DETAIL: '/ticket-group/self',

  // Loại ticket
  TICKET_TYPE_SEARCH: '/ticket-type/search',
  TICKET_TYPE_CREATE: '/ticket-type/create',
  TICKET_TYPE_UPDATE: '/ticket-type/update',
  TICKET_TYPE_UPDATE_STATUS: '/ticket-type/update-status',
  TICKET_TYPE_DELETE: '/ticket-type/delete',
  TICKET_TYPE_DETAIL: '/ticket-type/self',

  // Loại ticket theo đơn vị
  TICKET_TYPE_ORG_SEARCH: '/ticket-type-org/search',
  TICKET_TYPE_ORG_CREATE: '/ticket-type-org/create',
  TICKET_TYPE_ORG_UPDATE: '/ticket-type-org/update',
  TICKET_TYPE_ORG_UPDATE_STATUS: '/ticket-type-org/update-status',
  TICKET_TYPE_ORG_DELETE: '/ticket-type-org/delete',
  TICKET_TYPE_ORG_DETAIL: '/ticket-type-org/self',
  TICKET_TYPE_ORG_INIT: '/ticket-type-org/sync-ticket-type',
  TICKET_TYPE_ORG_DUE_TIME: '/ticket-type-org/due-date',

  // Quản lý ticket
  TICKET_MANAGE_SEARCH: '/ticket/search',
  TICKET_MANAGE_DETAIL: '/ticket/self',
  TICKET_MANAGE_CREATE: '/ticket/create',
  TICKET_MANAGE_UPDATE: '/ticket/update',
  TICKET_MANAGE_DELETE: '/ticket/delete',
  TICKET_MANAGE_CANCEL: '/ticket/cancel',
  TICKET_MANAGE_PROCESS: '/ticket/inprogress',
  TICKET_MANAGE_COMPLETE: '/ticket/complete',
  TICKET_MANAGE_NEW: '/ticket/new',
  TICKET_MANAGE_GET_ACTIONS_LIST: '/ticket-comment/search',
  TICKET_MANAGE_CREATE_ACTIONS_LIST: '/ticket-comment/create',
  TICKET_MANAGE_GET_HISTORY_LIST: '/ticket/history-change',
}

export const pjm = {
  GET_GLOBAL_LIST_DETAIL: '/pjm/globalListDetail/getListGlobalValueByCode',
  ASM_SEARCH: '/pjm/asset/search',

  //Danh sách dự án
  PROJECT_LIST_SEARCH: '/pjm/asset-project/search',
  PROJECT_LIST_SEARCH_APPROVE: '/pjm/asset-project/suggest',
  PROJECT_LIST_DETAIL: '/pjm/asset-project/self',
  PROJECT_LIST_FINANCIAL: '/pjm/asset-project/project-financial',
  PROJECT_LIST_UPDATE: '/pjm/asset-project/update',
  PROJECT_UPDATE_PER_STATE: '/pjm/asset-project/update-per-state',
  PROJECT_LIST_CREATE: '/pjm/asset-project/create',
  PROJECT_LIST_GRANT_ASSET: '/pjm/asset-project/grant-asset',
  PROJECT_LIST_REVOKE_ASSET: '/pjm/asset-project/revoke-asset',
  PROJECT_LIST_GET_DOC: '/pjm/asset-project-doc/search',
  PROJECT_LIST_UPDATE_DOC: '/pjm/asset-project-doc/update-batch',
  PROJECT_LIST_GENERATE_CODE: '/pjm/asset-project/generate-code',
  PROJECT_REQUEST_CLOSE: '/pjm/asset-project/request-close',
  PROJECT_CLOSE: '/pjm/asset-project/close',
  COST_ESTIMATE_DONE: '/pjm/project-cost-estimate/done',
  COST_ESTIMATE_SEARCH: '/pjm/project-cost-estimate/search',
  COST_ESTIMATE_SELF: '/pjm/project-cost-estimate/self',
  COST_ESTIMATE_CREATE: '/pjm/project-cost-estimate/create',
  COST_ESTIMATE_UPDATE: '/pjm/project-cost-estimate/update',
  COST_ESTIMATE_DELETE: '/pjm/project-cost-estimate/delete',
  COST_ESTIMATE_RAW_DATA: '/pjm/project-cost-estimate/search-raw',
  // Report
  PROJECT_FINANCIAL_YEAR_REPORT: '/pjm/project-financial/project-financial-year-report',

  // Chu kỳ cảnh báo
  PROJECT_AGGREGATION_CYCLE: '/pjm/aggregation-cycle/request-alert',
  PROJECT_AGGREGATION_CYCLE_SEARCH: '/pjm/aggregation-cycle/search',
  PROJECT_AGGREGATION_CYCLE_SEARCH_DATA: '/pjm/aggregation-cycle/search-data',
  PROJECT_AGGREGATION_CYCLE_SEARCH_EMAIL_LOG: '/pjm/aggregation-cycle/search-email-log',
  PROJECT_AGGREGATION_CYCLE_SEND_EMAIL: '/pjm/aggregation-cycle/send-email',

  //Danh sách hợp đồng của dự án
  CONTRACT_PROJECT_LIST_SEARCH: '/pjm/asset-project-contract/search',
  CONTRACT_PROJECT_LIST_DETAIL: '/pjm/asset-project-contract/self',
  CONTRACT_PROJECT_LIST_CREATE: '/pjm/asset-project-contract/create',
  CONTRACT_PROJECT_LIST_UPDATE: '/pjm/asset-project-contract/update',
  CONTRACT_PROJECT_LIST_DELETE: '/pjm/asset-project-contract/delete',
  CONTRACT_PROJECT_LIST_GET_DOC: '/pjm/asset-project-contract-doc/search',
  CONTRACT_PROJECT_LIST_UPDATE_DOC: '/pjm/asset-project-contract-doc/update-batch',

  // Nhà thầu
  PROJECT_CONTRACTOR_SEARCH: '/pjm/asset-project-contractor/search',
  PROJECT_CONTRACTOR_STORE: '/pjm/asset-project-contractor/create',
  PROJECT_CONTRACTOR_UPDATE: '/pjm/asset-project-contractor/update',
  PROJECT_CONTRACTOR_DELETE: '/pjm/asset-project-contractor/delete',
  PROJECT_CONTRACTOR_DETAIL: '/pjm/asset-project-contractor/self',
  PROJECT_CONTRACTOR_UPDATE_STATUS: '/pjm/asset-project-contractor/update-status',

  // Gói thầu
  BIDDING_PACKAGE_SEARCH: '/pjm/bidding-package/search',
  BIDDING_PACKAGE_SEARCH_GROUP_TYPE: '/pjm/bidding-package/search-group-type',
  BIDDING_PACKAGE_SELF: '/pjm/bidding-package/self',
  BIDDING_PACKAGE_CREATE: '/pjm/bidding-package/create',
  BIDDING_PACKAGE_UPDATE: '/pjm/bidding-package/update',
  BIDDING_PACKAGE_DELETE: '/pjm/bidding-package/delete',
  BIDDING_PACKAGE_DONE: '/pjm/bidding-package/done',

  // Nhà thầu
  BIDDING_PACKAGE_CONTRACTOR_SEARCH: '/pjm/bidding-package-contractor/search',
  BIDDING_PACKAGE_CONTRACTOR_CREATE: '/pjm/bidding-package-contractor/create',
  BIDDING_PACKAGE_CONTRACTOR_DELETE: '/pjm/bidding-package-contractor/delete',
  BIDDING_PACKAGE_CONTRACTOR_UPDATE: '/pjm/bidding-package-contractor/update',

  // Ngân sách - chi phí dự án
  PROJECT_FINANCIAL_SEARCH: '/pjm/project-financial/search',
  PROJECT_FINANCIAL_SELF: '/pjm/project-financial/self',
  PROJECT_FINANCIAL_CREATE: '/pjm/project-financial/create',
  PROJECT_FINANCIAL_UPDATE: '/pjm/project-financial/update',
  PROJECT_FINANCIAL_DELETE: '/pjm/project-financial/delete',
  // Hạng mục dự án
  PROJECT_COST_CATEGORY_SEARCH: '/pjm/project-cost-category/search',
  PROJECT_COST_CATEGORY_CREATE: '/pjm/project-cost-category/create',
  PROJECT_COST_CATEGORY_UPDATE: '/pjm/project-cost-category/update',
  PROJECT_COST_CATEGORY_SELF: '/pjm/project-cost-category/self',
  PROJECT_COST_CATEGORY_DELETE: '/pjm/project-cost-category/delete',

  // Dự án dự thảo
  DRAFT_PROJECT_SEARCH: '/pjm/draft-project/search',
  DRAFT_PROJECT_CREATE: '/pjm/draft-project/create',
  DRAFT_PROJECT_UPDATE: '/pjm/draft-project/update',
  DRAFT_PROJECT_SUBMIT: '/pjm/draft-project/submit',
  DRAFT_PROJECT_APPROVE: '/pjm/draft-project/approve',
  DRAFT_PROJECT_SELF: '/pjm/draft-project/self',
  DRAFT_PROJECT_DELETE: '/pjm/draft-project/delete',
  DRAFT_PROJECT_CANCEL: '/pjm/draft-project/cancel',
  DRAFT_PROJECT_GENERATE_REVIEWERS: '/pjm/draft-project/generate-reviewers',
  DRAFT_PROJECT_HISTORY_CHANGE: '/pjm/draft-project/history-change',
  DRAFT_PROJECT_REVOKE: '/pjm/draft-project/revoke',

  // Dự án - checklist tài liệu
  PROJECT_DOCUMENT_CHECKLIST_SEARCH: '/pjm/project-document-checklist/search',
  PROJECT_DOCUMENT_CHECKLIST_CREATE: '/pjm/project-document-checklist/create',
  PROJECT_DOCUMENT_CHECKLIST_UPDATE: '/pjm/project-document-checklist/update',

  //Thẩm định yêu cầu
  PROJECT_APPRAISAL_SEARCH: '/pjm/request/search',
  PROJECT_APPRAISAL_CREATE: '/pjm/request/create',
  PROJECT_APPRAISAL_UPDATE: '/pjm/request/update',
  PROJECT_APPRAISAL_DETAIL: '/pjm/request/self',
  PROJECT_APPRAISAL_DELETE: '/pjm/request/delete',
  PROJECT_APPRAISAL_UPDATE_STATUS: '/pjm/request/update-status',
  PROJECT_DETAIL: '/pjm/asset-project/request-generate-infor',

  //Kế hoạch dòng tiền
  CASH_FLOW_PLAN_SEARCH: '/pjm/cash-flow/search',
  CASH_FLOW_PLAN_SELF: '/pjm/cash-flow/self',
  CASH_FLOW_PLAN_CREATE: '/pjm/cash-flow/create',
  CASH_FLOW_PLAN_UPDATE: '/pjm/cash-flow/update',

  CASH_FLOW_PLAN_DELETE: '/pjm/cash-flow-detail/delete',
  CASH_FLOW_DETAIL_CREATE: '/pjm/cash-flow-detail/create',
  CASH_FLOW_DETAIL_SEARCH: '/pjm/cash-flow-detail/search',
  CASH_FLOW_DETAIL_PLAN_SELF: '/pjm/cash-flow-detail/self',
  CASH_FLOW_DETAIL_PLAN_UPDATE: '/pjm/cash-flow-detail/update',
  CASH_FLOW_DETAIL_PLAN_DELETE: '/pjm/cash-flow-detail/delete',
  HISTORY_DISBURSEMENT: '/pjm/cash-flow-detail-disbursement/search',
  CASH_FLOW_CHART: '/pjm/cash-flow/actual-vs-plan',
  HISTORY_UPDATE: '/pjm/cash-flow-history/search',
  HISTORY_SELF: '/pjm/cash-flow-history/self',
  GET_REQUEST_TITLE: '/pjm/request/generate-request-title',
  GET_REQUEST_REVIEWER_ORG_UNITS: '/pjm/request/generate-request-reviewer-org-units',
  GET_REQUEST_REVIEW_ORG_UNIT: '/pjm/request/generate-request-reviewer-org-units',
  CASH_FLOW_SEARCH_RAW: '/pjm/cash-flow/search-raw',

  // Dashboard
  DASHBOARD_SEARCH_ORG_UNIT: '/pjm/dashboard/search-org-unit',
  DASHBOARD_CHART_PROJECT_STATE: '/pjm/dashboard/chart-project-state',
  DASHBOARD_CHART_ADDITIONAL_EXPENSE: '/pjm/dashboard/chart-additional-expense',
  DASHBOARD_GENERAL: '/pjm/dashboard/general',
  DASHBOARD_TASK: '/pjm/dashboard/task',
  DASHBOARD_TOP_BIGGEST_CONTRACTOR: '/pjm/dashboard/top-biggest-contractor',
  DASHBOARD_TOP_DELAY_WORK_CONTRACTOR: '/pjm/dashboard/top-delay-work-contractor',
  DASHBOARD_CASH_FLOW_MONTH: '/pjm/dashboard/cash-flow-month',
  DASHBOARD_AGGREGATE: '/pjm/dashboard/aggregate',
  DASHBOARD_REQUEST_AGGREGATE: '/pjm/dashboard/request-aggregate',
  DASHBOARD_CASH_FLOW: '/pjm/dashboard/cash-flow',
  DASHBOARD_COST_ESTIMATE: '/pjm/dashboard/cost-estimate',
  DASHBOARD_CASH_FLOW_MONTH_PROJECT: '/pjm/dashboard/cash-flow-month-project',
  DASHBOARD_CHART_ADDITIONAL_EXPENSE_DETAIL: '/pjm/dashboard/chart-additional-expense-detail',
  DASHBOARD_TASK_DETAIL: '/pjm/dashboard/task-detail',
  DASHBOARD_TOP_BIGGEST_CONTRACTOR_DETAIL: '/pjm/dashboard/top-biggest-contractor-detail',
  DASHBOARD_TOP_DELAY_WORK_CONTRACTOR_DETAIL: '/pjm/dashboard/top-delay-work-contractor-detail',
}

export const fsm = {
  GET_FILE: '/file/list',
  UPLOAD_MULTIPART_FILE: '/fsm/file/upload-multipart',
}

export const tm = {
  TASK_LIST_SEARCH: '/pjm/task/search',
  TASK_LIST_SEARCH_GROUP_STATE: '/pjm/task/search-group-state',
  TASK_LIST_CREATE: '/pjm/task/create',
  TASK_LIST_UPDATE: '/pjm/task/update',
  TASK_LIST_DELETE: '/pjm/task/delete',
  TASK_LIST_SELF: '/pjm/task/self',
  TASK_HISTORY: '/pjm/task/history-change',
  TASK_LIST_RAW_SEARCH: '/pjm/task/search-raw',

  COMMENT_SEARCH: '/pjm/comment/search',
  COMMENT_CREATE: '/pjm/comment/create',
  COMMENT_UPDATE: '/pjm/comment/update',
  COMMENT_DELETE: '/pjm/comment/delete',
}

export const config = {
  // Checklist
  DOCUMENT_CHECKLIST_SEARCH: '/pjm/document-checklist/search',
  DOCUMENT_CHECKLIST_SELF: '/pjm/document-checklist/self',
  DOCUMENT_CHECKLIST_CREATE: '/pjm/document-checklist/create',
  DOCUMENT_CHECKLIST_UPDATE: '/pjm/document-checklist/update',
  DOCUMENT_CHECKLIST_DELETE: '/pjm/document-checklist/delete',

  // Checklist Detail
  DOCUMENT_CHECKLIST_DETAIL_SEARCH: '/pjm/document-checklist-detail/search',
  DOCUMENT_CHECKLIST_DETAIL_CREATE: '/pjm/document-checklist-detail/create',
  DOCUMENT_CHECKLIST_DETAIL_UPDATE: '/pjm/document-checklist-detail/update',
  DOCUMENT_CHECKLIST_DETAIL_DELETE: '/pjm/document-checklist-detail/delete',

  // Global list
  GLOBAL_LIST_SEARCH: '/pjm/globalList/searchGlobalList',
  GLOBAL_LIST_SYNC: '/pjm/globalList/synchronize',

  // Global list detail
  GLOBAL_LIST_DETAIL_GET_LIST: 'pjm/globalListDetail/getListGlobalValueByCode',
  GLOBAL_LIST_DETAIL_CREATE: 'pjm/globalListDetail/insertGlobalListDetail',
  GLOBAL_LIST_DETAIL_UPDATE: 'pjm/globalListDetail/updateGlobalListDetail',
  GLOBAL_LIST_DETAIL_DELETE: 'pjm/globalListDetail/removeGlobalListDetail',

  // setting aprraisal
  APRRAISAL_SETTING_SEARCH: '/pjm/config-request-org/search',
  APRRAISAL_SETTING_CREATE: '/pjm/config-request-org/create',
  APRRAISAL_SETTING_UPDATE: '/pjm/config-request-org/update',
  APRRAISAL_SETTING_DELETE: '/pjm/config-request-org/delete',
  APRRAISAL_SETTING_SELF: '/pjm/config-request-org/self',
  APRRAISAL_UPDATE_STATUS: '/pjm/config-request-org/update-status',

  // close project
  CLOSE_PROJECT_SEARCH: '/pjm/config-permission-close-project/search',
  CLOSE_PROJECT_CREATE: '/pjm/config-permission-close-project/create',
  CLOSE_PROJECT_UPDATE: '/pjm/config-permission-close-project/update',
  CLOSE_PROJECT_DELETE: '/pjm/config-permission-close-project/delete',
  CLOSE_PROJECT_SELF: '/pjm/config-permission-close-project/self',
  CLOSE_PROJECT_UPDATE_STATUS: '/pjm/config-permission-close-project/update-status',
}

// Yêu cầu phẩm định
export const rq = {
  CREATE_FILE_APPRAISAL: 'pjm/request/create',
}
